<template>
  <div class="doc-with-type-loader">
    <!-- <button>TestDoc</button> -->
    <FileLoader
      :showDocsList="false"
      :deleteItemIndex="deleteItemIndex"
      :initData="initDataForFileLoader"
      @changeFileList="changeFileList($event)"
      @setDocWidthType="setDocWidthType($event)"
    />
    <div class="item" v-for="(doc, index) in docs" :key="'doc-with-type_' + random + '_' + index">
      <div class="doc-title">
        <span class="doc-name">{{ doc.name }}</span>
        <div class="doc-type">
          <span v-if="doc.documentType === null || doc.documentType.length < 2">Обязательное поле</span>
          <input :title="doc.documentType" @click="showTree(index)" placeholder="Выбрать тип" type="text" v-model="doc.documentType">
        </div>
      </div>
      <div class="input-wrap">
        <span>Дата:</span>
        <input class="form-control" type="date" v-model="doc.date">
      </div>
      <div class="input-wrap">
        <span>Примечание:</span>
        <input class="form-control" type="text" v-model="doc.notes">
      </div>
      <div class="input-wrap">
        <span>Номер:</span>
        <input class="form-control" type="number" v-model="doc.number">
      </div>
      <div class="input-wrap">
        <span>Серия:</span>
        <input class="form-control" type="text" v-model="doc.seria">
      </div>
      <img @click="delItem(index)" class="doc-delete" src="@img/close.svg" alt="">
    </div>
    <div class="popup-tree">
      <PopupVue v-if="showTreePopup" @closePopup="showTreePopup = false">
        <template #content>
          <TreeComponent :initOnMount="true" :inputData="DocTypeList" :multiple="false" @setSelected="setSelected($event)" :selectParent="true"/>
        </template>
      </PopupVue>
    </div>
  </div>
</template>

<script>
import FileLoader from './FileLoader.vue'
import PopupVue from './PopupVue.vue'
import TreeComponent from './tree/TreeComponent.vue'
export default {
  components: { FileLoader, TreeComponent, PopupVue },
  props: ['initData'],
  data () {
    return {
      docs: [],
      random: '_',
      showTreePopup: false,
      selectedIndex: -1,
      deleteItemIndex: -1,
      initDataForFileLoader: null
    }
  },
  /* validations: {
    doc.documentType: {
      required
    },
    password: {
      required
    }
  }, */
  computed: {
    DocTypeList () {
      return this.createTreeListMix(this.$store.getters.DOCUMENT_TYPE_LIST)
    }
  },
  watch: {
    initData (newVal) {
      if (newVal !== undefined && newVal !== null && newVal.length > 0) {
        this.initDataForFileLoader = newVal
      }
    }
  },
  created () {
    this.random = (100 + Math.floor(500 * Math.random()))
  },
  methods: {
    qwe () {
      console.log(this.initDataForFileLoader)
    },
    setDocWidthType (e) {
      let initDocList = []
      e.forEach((doc, index) => {
        initDocList.push({
          file: doc.file,
          name: doc.name,
          date: this.initDataForFileLoader[index].date,
          notes: this.initDataForFileLoader[index].notes,
          number: this.initDataForFileLoader[index].number,
          seria: this.initDataForFileLoader[index].seria,
          uploadByUser: doc.uploadByUser,
          documentType: this.initDataForFileLoader[index].documentType,
          documentTypeCode: this.initDataForFileLoader[index].documentTypeCode
        })
      })
      this.docs = initDocList
      this.$emit('setDocumentsWithType', this.docs)
    },

    delItem (index) {
      this.docs.splice(index, 1)
      this.deleteItemIndex = index
      this.$nextTick(e => {
        this.deleteItemIndex = -1
      })
    },
    setSelected (e) {
      this.docs[this.selectedIndex].documentType = e.fullInfo[0].text
      this.docs[this.selectedIndex].documentTypeCode = e.fullInfo[0].id
      this.showTreePopup = false
      this.$emit('setDocumentsWithType', this.docs)
    },

    showTree (index) {
      this.selectedIndex = index
      this.showTreePopup = true
    },

    changeFileList (e) {
      if (e.length === 0) {
        this.docs = []
      } else { // если добавили документ
        let newDocs = []
        e.forEach(item => {
          let doc = this.docs.find(_doc => { // ищем есть ли он уже
            return _doc.name === item.name
          })
          if (doc !== undefined) { // если нашли добавляем c имеющимися данными
            newDocs.push({
              name: doc.name,
              documentType: doc.documentType,
              documentTypeCode: doc.documentTypeCode,
              doc: doc,
              uploadByUser: doc.uploadByUser
            })
          } else {
            newDocs.push({
              name: item.name,
              documentType: null,
              documentTypeCode: null,
              doc: item,
              uploadByUser: item.uploadByUser
            })
          }
        })
        this.docs = newDocs
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  position: relative;
  span {
    font-size: 12px;
    display: block;
    margin-bottom: 5px;
  }
}
.doc-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 5px;
}
.doc-name {
  // font-size: 12px;
  width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.doc-type {
  font-size: 12px;
  width: 190px;
  margin-left: 15px;
  margin-right: 20px;
  span {
    color: #FF3D00;
  }
  input {
    width: 100%;
    border: none;
    cursor: pointer;
    background-color: transparent;
  }
}
.doc-delete {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
.popup-tree {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/DocWithTypeLoader.vue